export const EMPTY_PRE_CALC_RECOMMENDATION_TEXT = "אין המלצות";

export function getPreCalcRecommendationDisplayText(recommendations, soldPropertyDate) {
  if (!recommendations) return EMPTY_PRE_CALC_RECOMMENDATION_TEXT;
  const recommendationText =
    soldPropertyDate >= "2018-01-01" ? recommendations.recAfter2018 : recommendations.recBefore2018;
  if (typeof recommendationText !== "string" || recommendationText.trim() === "") {
    return EMPTY_PRE_CALC_RECOMMENDATION_TEXT;
  }
  return recommendationText;
}
